import React, { useEffect, useState } from 'react'
import { RootState } from '../../../global/config/store';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, Box, FormControl, IconButton, Stack, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { ApiGetClientEntityByClientGroupId, ApiGetVenueList, ApiGetShopperList, ApiGetCompleteAllocation } from '../../../apiService/Core/Apicall.tsx';
import useDebounce from '../CreateAllocations/UseDebounce.tsx';
import { toast } from 'react-toastify';
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';
import { setDate } from '../../../global/config/Reducer/dateSlice.ts';

interface CompleteAllocationRow {
    venueId: {
        venueName: string;
        venueCode?: string;
        address?: string;
        postalCode?: string;
        tradingHours?: string;
        websiteURL?: string;
        shopTypeId: {
            shopTypeName?: string;
        };
    };
    userId: {
        firstName: string;
        lastName: string;
    };
    appliedAllocations: {
        selectedVisitDate?: string;
        selectedVisitTime: {
            visitTimeInformation: string;
        }
    };
    checkInLat: number;
    checkInLong: number;
    checkOutLat: number;
    checkOutLong: number;
    checkInDateTime?: string;
    checkOutDateTime?: string;
    createdOn: string;
    visitTimeInformation?: string;
    checkInImage?: string;
    checkOutImage?: string;
}
function CompleteAllocation() {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch()
    const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
    const [venueName, setVenueName] = useState([])
    const [venueNameValue, setVenueNameValue] = useState<any>(null)
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [clientEntityId, setClientEntityId] = useState<string | null>(null)
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const [ClientId, setClientId] = useState(null)
    const [venue, setVenue] = useState([])
    const debouncedClientEntityId = useDebounce(clientEntityId, 500)
    const [shopperlist, setshopperlist] = useState([])
    const [details, setDetails] = useState<CompleteAllocationRow[]>([])
    const [selectedShopper, setSelectedShopper] = useState<any>()
    const [searchShopper, setsearchShopper] = useState<any>([])
    const [datalength, setdatalength] = useState<any>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2]);
            setClientId(Clientlist[2].clientGroupName);
        }
    }, [Clientlist]);


    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])

    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        setCurrentDate(newDate)
        dispatch(setDate(event.target.value))
    }

    useEffect(() => {
        if(selectedDateRedux) {
          setCurrentDate(new Date(selectedDateRedux))
        }
      },[selectedDateRedux])

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    }
    useEffect(() => {
        if (clientEntityId === null) {
            setVenueName([])
        }
    }, [clientEntityId])


    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            setClientEntityList(res.data)
            // setClientEntityId(res.data[0].clientEntityId)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
        let data = `?offset=0&limit=500`
        if (clientEntityId) {
            data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        } else if (selectedClient) {
            data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        }
        const res = await ApiGetVenueList(data)
        setVenue(res?.data)
        const response = res?.data.map((item) => ({
            label: item.venueName,
            value: item.venueId,
            state: item.state,
            entityTypeName: item.entityTypeName
        }))
        setVenueName(response)
        // setVenueNameValue(response[0]?.value);
    }
    useEffect(() => {
        if (debouncedClientEntityId || selectedClient) {
            ApiCallGetVenueList(debouncedClientEntityId)
        } else {
            setVenueName([])
            setVenueNameValue(null)
        }
    }, [debouncedClientEntityId, selectedClient])
    const getShopperList = async (text) => {
        setshopperlist([])
        try {
            const data = `?offset=0&limit=1000${text?.length > 0 ? `&search=${text}` : ''}`
            const res = await ApiGetShopperList(data)
            const originonal = res.data
            setshopperlist(originonal)
            const defaultselected = (res.data?.filter(item => item.firstName !== ''))
            // setSelectedShopper(defaultselected[0])

        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {
        getShopperList(searchShopper);
    }, [searchShopper])
    const jobMonth = currentDate.getMonth() + 1;
    const jobYear = currentDate.getFullYear();

    const ApiCallGetCompletedAllocation = async (jobMonth: number, jobYear: number) => {
        let data = `?offset=${rowsPerPage * page}&limit=${rowsPerPage}&jobMonth=${jobMonth}&jobYear=${jobYear}`;
        if (venueNameValue) data += `&venueId=${venueNameValue}`;
        if (selectedShopper) data += `&userId=${selectedShopper?.userId}`;
        if (selectedClient) data += `&allocationClientGroup=${selectedClient?.clientGroupName}`
        if (clientEntityId) data += `&clientEntityId=${clientEntityId}`

        try {
            const res = await ApiGetCompleteAllocation(data);
            setDetails(res?.data || []);
            setdatalength(res?.totalCount);
        } catch (error) {
            console.error("Error fetching allocations:", error);
            toast.error("Failed to load allocations");
            setdatalength(0)
        }
    };
    console.log('Shopt Type', details);

    useEffect(() => {
        ApiCallGetCompletedAllocation(
            currentDate.getMonth() + 1,
            currentDate.getFullYear()
        );
    }, [currentDate, venueNameValue, selectedShopper, clientEntityId, selectedClient, rowsPerPage, page]);

    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box sx={{ p: 4 }} style={{ background: "white" }}>
            <Stack spacing={3}>
                <Box sx={{ width: "100%" }}>
                    <h1 className="common-manage-h1 mt-0 col-6" style={{ textAlign: "end", marginLeft: "250px" }}>
                        Allocation Completed
                    </h1>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: 'center',
                            gap: 2,
                            marginTop: "23px",
                            flexWrap: "wrap",
                            flexDirection: { xs: "column", sm: "column", md: "row" }
                        }}
                    >
                        <Stack direction={{ xs: "column", sm: "column", md: "row" }} sx={{ width: { xs: "100%", md: "auto" } }} spacing={2}>
                            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                <Autocomplete
                                    disablePortal
                                    id="mm-autocomplete"
                                    options={Clientlist}
                                    value={selectedClient}
                                    getOptionLabel={(option: any) => option?.clientGroupName}
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option.clientGroupDBName === value.clientGroupDBName
                                    }
                                    onChange={(event, newValue: any) => {
                                        // setSelectedClient(newValue)
                                        dispatch(setSelectedClientGroup(newValue))
                                        setClientId(newValue?.clientGroupName || null)
                                        // if (!newValue || (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)) {
                                            setClientEntityId(null)
                                            setVenueNameValue(null)
                                            setClientEntityList([])
                                        // }
                                    }}
                                    defaultValue="mmcommon"
                                    renderInput={(params) => <TextField {...params} label="Select Client" />}
                                    size="small"
                                />
                            </FormControl>
                        </Stack>
                        <Stack direction={{ xs: "column", sm: "column", md: "row" }} sx={{ width: { xs: "100%", md: "auto" } }} spacing={2}>
                            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                <Autocomplete
                                    disablePortal
                                    id="beacon-autocomplete"
                                    options={clientEntityList?.filter((item) => item.clientEntityId !== null)}
                                    getOptionLabel={(option) => option?.entityName || ""}
                                    onChange={(event, newValue: any) => {
                                        setClientEntityId(newValue?.clientEntityId || null)
                                        if (!newValue) {
                                            setVenueNameValue(null)
                                        }
                                    }}
                                    value={clientEntityList?.find((option) => option?.clientEntityId === clientEntityId) || null}
                                    renderInput={(params) => <TextField {...params} label="Select Business" />}
                                    size="small"
                                />
                            </FormControl>
                            <FormControl size="small" sx={{ width: { xs: "100%", md: 250 } }}>
                                <Autocomplete
                                    disablePortal
                                    id="mm-autocomplete"
                                    options={venueName}
                                    getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                                    value={venueName.find((option: any) => option.value === venueNameValue) || null}
                                    onChange={(event, newValue: any) => {
                                        setVenueNameValue(newValue?.value)
                                    }}
                                    defaultValue=""
                                    renderInput={(params) => <TextField {...params} label="Select Site" />}
                                    size="small"
                                />
                            </FormControl>
                        </Stack>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginLeft: "220px",
                                width: { xs: "100%", md: 180 }
                            }}
                        >
                            <IconButton onClick={handlePrevMonth}>
                                <ChevronLeftIcon />
                            </IconButton>
                            <Box sx={{ display: "flex", alignItems: "center", mx: 0 }}>
                                <input
                                    type="month"
                                    value={formatDate(currentDate)}
                                    onChange={handleDateChange}
                                    className="primary-color"
                                    style={{
                                        border: "none",
                                        background: "none",
                                        fontSize: "1.25rem",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        fontFamily: "inherit",
                                    }}
                                />
                            </Box>
                            <IconButton onClick={handleNextMonth}>
                                <ChevronRightIcon />
                            </IconButton>
                        </Box>
                        <Box className='d-flex justify-content-end' flexGrow={1}>
                            <Stack direction={{ xs: "column", sm: "column", md: "row" }} sx={{ width: { xs: "400%", md: "auto" } }} spacing={2}>
                                <FormControl className="w-400" size="small" sx={{ width: { xs: "400%", md: 250 } }}>
                                    <Autocomplete
                                        // sx={{maxWidth:'450px'}}
                                        id='serach_shopper'
                                        disablePortal
                                        options={shopperlist?.filter((item: any) => item?.firstName !== '')}
                                        value={selectedShopper}
                                        onInputChange={(event, newInputValue) => { setsearchShopper(newInputValue) }}
                                        getOptionLabel={(option: any) => `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`}
                                        isOptionEqualToValue={(option: any, value: any) =>
                                            option.userId === value.userId || option.emailId === value.emailId
                                        }
                                        filterOptions={(options, { inputValue }) =>
                                            options.filter((option) => {
                                                const fullName = `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`.toLowerCase();
                                                const email = option.emailId?.toLowerCase() || '';
                                                const search = inputValue.toLowerCase();
                                                return fullName.includes(search) || email.includes(search);
                                            })
                                        }
                                        onChange={(event, newValue: any) => {
                                            setSelectedShopper(newValue)
                                        }}
                                        // defaultValue={shopperlist?.filter(item => item.firstName !== '')[0]}
                                        renderInput={(params) => <TextField {...params} label="Select Shopper" />} size="small"
                                    />
                                </FormControl>
                            </Stack>
                        </Box>
                    </Box>
                </Box>
            </Stack>
            <Box sx={{ width: '100%', marginTop: 5 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#757b52' }}>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Site</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Visit Details</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Check In</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Check Out</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {details.length > 0 ? details?.map((row, index) => (
                            <TableRow key={index} sx={{ verticalAlign: 'top' }}>
                                <TableCell>
                                    <Typography fontWeight="bold">{row?.venueId?.venueName}</Typography>
                                    <Typography variant="body2">({row?.venueId?.shopTypeId?.shopTypeName || 'N/A'})</Typography>
                                    <Box mt={5}>
                                        <Typography>
                                            <b>Address:</b> {row?.venueId?.address}
                                        </Typography>
                                        <Typography>
                                            <b>PostCode:</b> {row?.venueId?.postalCode}
                                        </Typography>
                                        <Typography>
                                            <b>Trading hours:</b> {row.venueId?.tradingHours}
                                        </Typography>
                                        <Typography>
                                            <b>Website:</b>{' '}
                                            <a href={row?.venueId?.websiteURL} target="_blank" rel="noopener noreferrer">
                                                {row?.venueId?.websiteURL}
                                            </a>
                                        </Typography>
                                    </Box>
                                </TableCell>

                                <TableCell>
                                    <Box mt={10}>
                                        <Typography>
                                            <b>Allocated Date:</b> <br /> {row?.appliedAllocations[0]?.selectedVisitDate ? new Date(row?.appliedAllocations[0]?.selectedVisitDate).toLocaleDateString() : 'N/A'}
                                        </Typography>
                                        <Typography>
                                            <b>Allocated Time:</b> {row?.appliedAllocations[0]?.selectedVisitTime?.visitTimeInformation || "N/A"}
                                        </Typography>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box mt={10}>
                                        <Typography>
                                            <b>Check In Date:</b> <br /> {row.checkInDateTime ? new Date(row.checkInDateTime).toLocaleDateString() : 'N/A'}
                                        </Typography>
                                        <Typography>
                                            <b>Check In Time:</b> {row.checkInDateTime ? new Date(row.checkInDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A'}
                                        </Typography>
                                        <Box mt={1}>
                                            {row.checkInLat && row.checkInLong ? (
                                                <a
                                                    href={`https://www.google.com/maps?q=${row.checkInLat},${row.checkInLong}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    // style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                                >
                                                    View CheckIn Location
                                                </a>
                                            ) : (
                                                <span style={{ color: "gray" }}>Location unavailable</span>
                                            )}
                                        </Box>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box mt={10}>
                                        <Typography>
                                            <b>Check Out Date:</b><br /> {row.checkOutDateTime ? new Date(row.checkOutDateTime).toLocaleDateString() : 'N/A'}
                                        </Typography>
                                        <Typography>
                                            <b>Check Out Time:</b> {row.checkOutDateTime ? new Date(row.checkOutDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A'}

                                        </Typography>
                                        <Box mt={1}>
                                            <Box mt={1}>
                                                {row.checkOutLat && row.checkOutLong ? (
                                                    <a
                                                        href={`https://www.google.com/maps?q=${row.checkOutLat},${row.checkOutLong}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        // style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                                    >
                                                        View CheckOut Location
                                                    </a>
                                                ) : (
                                                    <span style={{ color: "gray" }}>Location unavailable</span>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )) : <TableRow><TableCell colSpan={4}>No Data Found</TableCell></TableRow>}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>
        </Box>
    )
}
export default CompleteAllocation;